
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { LogIn, PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/language";

interface GuestPromptProps {
  type: "alert" | "fullPage";
}

const GuestPrompt = ({ type }: GuestPromptProps) => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  
  if (type === "alert") {
    return (
      <Alert className="mb-6">
        <LogIn className="h-4 w-4" />
        <AlertTitle>
          {language === 'ja' ? 'ゲストモード' : 'Guest Mode'}
        </AlertTitle>
        <AlertDescription>
          {language === 'ja' 
            ? 'エントリーを表示および管理するにはログインが必要です。' 
            : 'You need to sign in to view and manage your entries.'}
          <Button 
            variant="link" 
            className="p-0 h-auto"
            onClick={() => navigate("/login", { state: { returnTo: "/entries" } })}
          >
            {language === 'ja' ? 'ログインする' : 'Sign in now'}
          </Button>
        </AlertDescription>
      </Alert>
    );
  }
  
  return (
    <div className="text-center p-12 border rounded-lg">
      <h3 className="font-medium text-lg">
        {language === 'ja' ? 'ログインして日記を表示する' : 'Sign in to view your entries'}
      </h3>
      <p className="text-muted-foreground mt-3 mb-4">
        {language === 'ja' 
          ? 'エントリーを表示および管理するにはアカウントが必要です。' 
          : 'You need an account to view and manage your diary entries.'}
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-4">
        <Button onClick={() => navigate("/login", { state: { returnTo: "/entries" } })}>
          <LogIn className="h-4 w-4 mr-2" />
          {language === 'ja' ? 'ログイン' : 'Sign In'}
        </Button>
        <Button variant="outline" onClick={() => navigate("/generate")}>
          <PlusCircle className="h-4 w-4 mr-2" />
          {language === 'ja' ? '日記を作成してみる' : 'Try creating an entry'}
        </Button>
      </div>
    </div>
  );
};

export default GuestPrompt;
